import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { StyledTextField } from "../../TextField/TextField";

export default function KenexaAPISection(props) {
  const useStyles = makeStyles((theme) => ({
    error: {
      color: theme.palette.error.main,
    },
    textField: {
      "& .Mui-error": {
        color: theme.palette.error.main,
      },
      "& .MuiFormHelperText-root": {
        color: theme.palette.error.main,
      },
      "& .MuiInput-underline.Mui-error:after": {
        borderBottomColor: theme.palette.error.main,
      },
    },
  }));

  const classes = useStyles();
  return (
    <>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Version"
          value={props.version}
          error={props.showInputError && props.version === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setVersion(e.target.value)}
        />
        {props.showInputError && props.version === "" && (
          <FormHelperText className={classes.error}>
            Version Required
          </FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Credential"
          value={props.credential}
          error={props.showInputError && props.credential === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setCredential(e.target.value)}
        />
        {props.showInputError && props.credential === "" && (
          <FormHelperText className={classes.error}>
            Credential Required
          </FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="User ID"
          value={props.userID}
          error={props.showInputError && props.userID === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setUserID(e.target.value)}
        />
        {props.showInputError && props.userID === "" && (
          <FormHelperText className={classes.error}>
            User ID Required
          </FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Site ID"
          value={props.siteID}
          error={props.showInputError && props.siteID === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setSiteID(e.target.value)}
        />
        {props.showInputError && props.siteID === "" && (
          <FormHelperText className={classes.error}>
            Site ID Required
          </FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Mapping File Name"
          value={props.mappingFileName}
          error={props.showInputError && props.mappingFileName === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setMappingFileName(e.target.value)}
        />
        {props.showInputError && props.mappingFileName === "" && (
          <FormHelperText className={classes.error}>
            Mapping File Name Required
          </FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Processor"
          value={props.processor}
          error={props.showInputError && props.processor === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setProcessor(e.target.value)}
        />
        {props.showInputError && props.processor === "" && (
          <FormHelperText className={classes.error}>
            Processor Required
          </FormHelperText>
        )}
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Additional Qustion IDs"
          value={props.additionalQuestionIds}
          error={props.showInputError && props.additionalQuestionIds === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          onChange={(e) => props.setAdditionalQuestionIds(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Country"
          value={props.country}
          error={props.showInputError && props.country === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          onChange={(e) => props.setCountry(e.target.value)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <StyledTextField
          InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
          label="Req Number Field ID"
          value={props.reqNumberFieldID}
          error={props.showInputError && props.reqNumberFieldID === ""}
          className={classes.textField}
          variant="standard"
          fullWidth
          required
          onChange={(e) => props.setReqNumberFieldID(e.target.value)}
        />
        {props.showInputError && props.reqNumberFieldID === "" && (
          <FormHelperText className={classes.error}>
            Field ID Required
          </FormHelperText>
        )}
      </Grid>
      <Grid xs={12} sm={12} item>
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={props.addPostedDate}
              onChange={(e) => props.setAddPostedDate(!props.addPostedDate)}
            />
          }
          label="Add Posted Date"
        />
      </Grid>
    </>
  );
}
